import { useNavigate } from 'react-router-dom';

import { EmphasizeCircleIcon } from '@_shared/icons';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { InformationPopup } from '@_shared/ui/Popup';

export function ContentCreateQuitPopup() {
	const navigate = useNavigate();
	const { popLayer } = useUILayerStore();

	return (
		<InformationPopup.Container closePopup={popLayer}>
			<EmphasizeCircleIcon />
			<InformationPopup.TextContainer>
				<InformationPopup.Title>저장을 취소하시겠어요?</InformationPopup.Title>
			</InformationPopup.TextContainer>
			<InformationPopup.ButtonContainer>
				<InformationPopup.Button type="deny" onClick={popLayer}>
					아니요
				</InformationPopup.Button>
				<InformationPopup.Button
					type="confirm"
					onClick={() => {
						popLayer();
						navigate(-1);
					}}
				>
					네, 취소할게요
				</InformationPopup.Button>
			</InformationPopup.ButtonContainer>
		</InformationPopup.Container>
	);
}
